import { render } from "./CourseRegistryCreate.vue?vue&type=template&id=ed7c8f7c"
import script from "./CourseRegistryCreate.vue?vue&type=script&lang=js"
export * from "./CourseRegistryCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__